import { Sidebar } from "./components/Sidebar";
import { VhsOverlay } from "./components/VhsOverlay";
import { FontLab } from "./components/FontLab";
import { AppModalProvider } from "./components/modal/AppModalContext";
import { useScrollSpy } from "./lib/hooks";
import { About } from "./sections/About";
import { Work } from "./sections/Work";
import { FilmLab } from "./sections/FilmLab";
import { Projects } from "./sections/Projects";
import { Letterboxd } from "./sections/Letterboxd";
import { Cars } from "./sections/Cars";
import { Resume } from "./sections/Resume";

const SECTION_IDS = ["about", "work", "lab", "projects", "letterboxd", "cars"];

export default function App() {
  // Tiny path switch (SPA fallback serves index.html for any route). The
  // /fonts type-tester is a throwaway compare page.
  const path =
    typeof window !== "undefined" ? window.location.pathname.replace(/\/+$/, "") : "";
  if (path === "/fonts") return <FontLab />;
  if (path === "/resume") return <Resume variant="normal" />;
  if (path === "/resume/slate_auto") return <Resume variant="slate_auto" />;
  return <MainSite />;
}

function MainSite() {
  const active = useScrollSpy(SECTION_IDS);

  return (
    <AppModalProvider>
      <VhsOverlay />
      <div className="flex min-h-dvh flex-col md:flex-row">
        <Sidebar active={active} />
        <main className="relative min-w-0 flex-1 px-[clamp(20px,6vw,80px)]">
          <div className="mx-auto max-w-5xl">
            <About />
            <Work />
            <FilmLab />
            <Projects />
            <Letterboxd />
            <Cars />
            <footer className="py-12 font-mono text-[13px] tracking-wide text-text-mute">
              © {new Date().getFullYear()} AJ Gerstenhaber · grstnhbr.com
            </footer>
          </div>
        </main>
      </div>
    </AppModalProvider>
  );
}
